import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const IndicatorContainer = superstyled({
  tag: Stack,
  name: 'PersonalizationIndicator',
  slot: 'IndicatorContainer',
  styles: () => ({
    alignItems: 'center',
    justifyContent: 'center',
    marginBlock: '0.75rem 0.25rem',
  }),
});
